import styled from 'styled-components';

import { LoadingIndicator } from '@spotify-internal/encore-creator-web';

export const LightModeLoadingIndicator = styled(LoadingIndicator)`
  /*
   * Calculated using https://codepen.io/sosuke/pen/Pjoqqp on klein blue
   * (#4100f5) with a loss of 0.1
   */
  filter: invert(11%) sepia(93%) saturate(6343%) hue-rotate(260deg)
    brightness(85%) contrast(133%);
`;
